import { DataConnection, DataGlueGraph, NodeInstance } from '../Graph';
import { isVector } from '../../helpers/Vector';

export function isGraphContent(input: any): input is { nodeInstances: NodeInstance[]; connections: DataConnection[] } {
    return (
        typeof input === 'object' &&
        Array.isArray(input.nodeInstances) &&
        input.nodeInstances.every(isNodeInstance) &&
        Array.isArray(input.connections) &&
        input.connections.every(isDataConnection)
    );
}

export function isDataGlueGraph(input: any): input is DataGlueGraph {
    return (
        typeof input === 'object' &&
        Array.isArray(input.nodeInstances) &&
        input.nodeInstances.every(isNodeInstance) &&
        Array.isArray(input.connections) &&
        input.connections.every(isDataConnection)
    );
}

export function isDataConnection(input: any): input is DataConnection {
    return (
        typeof input === 'object' &&
        typeof input.id === 'number' &&
        typeof input.receivingNodeInstanceId === 'number' &&
        typeof input.receivingPortName === 'string' &&
        typeof input.sendingNodeInstanceId === 'number' &&
        typeof input.sendingPortName === 'string'
    );
}

export function isNodeInstance(input: any): input is NodeInstance {
    return (
        (typeof input === 'object' &&
            typeof input.id === 'number' &&
            typeof input.nodeId === 'string' &&
            isVector(input.position) &&
            typeof input.selected === 'boolean' &&
            typeof input.subGraphId === 'number') ||
        (typeof input.subGraphId === 'undefined' &&
            typeof input.portValues === 'object' &&
            Array.isArray(input.inPorts) &&
            Array.isArray(input.outPorts) &&
            (typeof input.width === 'number' || typeof input.width === 'undefined') &&
            (typeof input.height === 'number' || typeof input.height === 'undefined') &&
            (typeof input.selectedVariable === 'string' || typeof input.selectedVariable === 'undefined'))
    );
}
